import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import '@marvelapp/marvel-ui/lib/styles.css';
import '@marvelapp/marveloucss/marveloucss.css';

import DefaultHeader from 'marketing-website/components/modules/Header';
import DeveloperHeader from 'marketing-website/components/modules/DevHeader';
import Footer from 'marketing-website/components/modules/Footer';
import Banner from 'marketing-website/components/modules/Banner';
import CookieStyles from 'marketing-website/components/modules/CookieStyles';

import favicon from 'marketing-website/media/images/favicon.png';

import { HOST } from 'marketing-website/configs/urls';

import './style.css';

function Page({
  children,
  footer,
  header,
  location,
  meta,
  title,
  banner,
  schema,
}) {
  const link = [
    {
      name: 'link',
      rel: 'shortcut icon',
      type: 'image/png',
      href: favicon,
    },
    {
      rel: 'canonical',
      href: HOST + location.pathname.replace(/\/+$/, ''),
    },
  ];

  const headers = {
    default: DefaultHeader,
    developer: DeveloperHeader,
  };

  if (header === true) {
    // eslint-disable-next-line no-param-reassign
    header = Page.defaultProps.header;
  } else if (typeof header === 'object') {
    // eslint-disable-next-line no-param-reassign
    header = {
      ...Page.defaultProps.header,
      ...header,
    };
  }

  const Header = header && header.type ? headers[header.type] : null;

  return (
    <div>
      <Helmet
        title={title}
        htmlAttributes={{ lang: 'en' }}
        meta={meta}
        link={link}
      >
        {schema && <script type="application/ld+json">{schema}</script>}
      </Helmet>
      {banner && <Banner />}
      {header && <Header {...header} />}
      {children}
      {footer && <Footer {...footer} />}
      <CookieStyles />
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  header: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  banner: PropTypes.bool,
  location: PropTypes.object,
  meta: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  schema: PropTypes.string,
};

Page.defaultProps = {
  header: { type: 'default' },
};

export default withRouter(Page);



// WEBPACK FOOTER //
// ./src/components/modules/Page/index.js